"use client"

import { create } from "zustand"

type AuthModalMode = "login" | "register" | "forgot-password"
type AuthAction = "view-plan" | "buy-plan" | "quote" | null

interface AuthModalState {
  isOpen: boolean
  mode: AuthModalMode
  pendingAction: AuthAction
  planSlug: string | null
  onSuccess?: () => void
}

interface AuthModalActions {
  openModal: (
    mode: AuthModalMode,
    action?: AuthAction,
    planSlug?: string,
    onSuccess?: () => void
  ) => void
  closeModal: () => void
  switchMode: (mode: AuthModalMode) => void
  executePendingAction: () => void
}

export const useAuthModalStore = create<AuthModalState & AuthModalActions>()(
  (set, get) => ({
    isOpen: false,
    mode: "login",
    pendingAction: null,
    planSlug: null,
    onSuccess: undefined,

    openModal: (mode, action = null, planSlug, onSuccess) => {
      set({
        isOpen: true,
        mode,
        pendingAction: action,
        planSlug: planSlug ?? null,
        onSuccess,
      })
    },

    closeModal: () => {
      set({
        isOpen: false,
        pendingAction: null,
        planSlug: null,
        onSuccess: undefined,
      })
    },

    switchMode: (mode) => {
      set({ mode })
    },

    executePendingAction: () => {
      const { onSuccess } = get()
      if (onSuccess) {
        onSuccess()
      }
      get().closeModal()
    },
  })
)
